import {getNodeCatalogUrl} from "../../constants/apiEndpoints";
import {initRequest} from "../../middlewares/request/requestActions";

export const CATALOG_FETCH = "catalog/fetch";
export const CATALOG_CLEAR = "catalog/clear";

export const fetchCatalog = (nodeId, nodeCode, baseUrl) =>
  initRequest(
    CATALOG_FETCH,
    getNodeCatalogUrl(nodeId),
    undefined,
    undefined,
    t => ({
      onStart: t("domains.catalog.messages.fetch.start")
    }),
    {
      nodeId,
      nodeCode
    },
    baseUrl
  );

export const clearCatalog = () => ({
  type: CATALOG_CLEAR
});
